import { all, call, delay, put, select, takeLatest } from 'redux-saga/effects'

import * as actions from '../actionTypes'
import { PER_PAGE, PROGRESS_INDICATOR_TIMEOUT } from '../constants'
import { getActiveProjects, getFilters } from '../api'
import { getSelectedFilters, scrollToTopOfResults } from '../utils'

function* activeProjectsRequestSaga(action) {
  try {
    const { pageNumber, scrollToTop, sortBy } = action.payload
    const filters = yield select(({ projectBoard }) => getSelectedFilters(projectBoard.filters))
    const { results: activeProjects, pageSize, total } = yield call(
      getActiveProjects,
      filters,
      pageNumber,
      sortBy
    )
    yield delay(PROGRESS_INDICATOR_TIMEOUT) // prevent progress indicator flash
    yield put({
      type: actions.PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST_SUCCESS,
      payload: {
        activeProjects,
        pageNumber,
        pageSize,
        totalPages: Math.ceil(total / PER_PAGE),
        totalResults: total,
      },
    })
    if (!sortBy) {
      // reset sort to initial state
      yield put({ type: actions.PROJECT_BOARD_SET_SORT_BY, payload: { sortBy: '' } })
    }
    if (scrollToTop) scrollToTopOfResults()
  } catch (e) {
    yield put({ type: actions.PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST_FAILURE, payload: e })
  }
}

function* filterSaga() {
  try {
    const filters = yield all({
      attendings: getFilters('attendings'),
      departments: getFilters('departments'),
      positions: getFilters('positions'),
      divisions: getFilters('divisions'),
    })
    yield put({
      type: actions.FILTER_REQUEST_SUCCESS,
      payload: filters,
    })
  } catch (e) {
    yield put({ type: actions.FILTER_REQUEST_FAILURE, payload: e })
  }
}

const projectBoardSaga = [
  takeLatest(actions.PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST, activeProjectsRequestSaga),
  takeLatest(actions.FILTER_REQUEST, filterSaga),
]

export default projectBoardSaga
